module.exports = __webpack_public_path__ + "static/rnb-reactive-2-56c88e17a8d04c3f0b79bfb79e6d482b.png";